import { stringify } from 'query-string';

import { FetchCrudData, FoodType, FoodTypeField, SORT_ORDER } from '../models';
import { Network } from '../utils';

export const getFoodTypes = async (filters: FetchCrudData): Promise<FoodType[]> => Network.get(`foodTypes?${stringify(filters)}`);
export async function getFoodTypeWithMinHoldingTime(): Promise<FoodType> {
  const queryParams = {
    sort: [`${FoodTypeField.MAX_HOLD_TIME},${SORT_ORDER.ASC}`],
    offset: 0,
    limit: 1,
  };
  return Network.get(`foodTypes?${stringify(queryParams)}`);
}
export const addFoodTypes = async (foodType: FoodType) => Network.post('foodTypes', foodType);
export const editFoodTypes = async (foodType: FoodType) => Network.patch(`foodTypes/${foodType.id}`, foodType);
export const deleteFoodTypes = async (id: string) => Network.delete(`foodTypes/${id}`);
